import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";


const LineBarChartSkeleton = () =>
    <>
        <Box sx={{ display: 'flex', flexDirection: 'row', width: 'auto', margin: '6px' }}>
            <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width={200} height={28} />
                <Skeleton variant="text" width={280} height={20} sx={{ mt: 1 }} />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Skeleton variant="rectangular" width={180} height={56} />
            </Box>
        </Box>
        <Box sx={{ width: '100%', padding: '16px', flex: 1 }}>
            <Paper sx={{
                width: '100%',
                height: '100%',
                minHeight: 300,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }} elevation={0}>
                <Skeleton variant="rectangular" width="90%" height="80%" />
            </Paper>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 'auto' }}>
            <Skeleton variant="text" width={120} height={30} />
        </Box>
    </>

export default LineBarChartSkeleton;
